import { useEffect } from 'react';

import { useRestrictedActionIndexActions } from './RestrictedActionIndexContext';

import { getRestrictedActions } from './restApi';

const RestrictedActionIndexLoader = () => {
  const { initializeState, onResponse, onError } = useRestrictedActionIndexActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getRestrictedActions({ onResponse, onError });
  }, []);

  return null;
};

export default RestrictedActionIndexLoader;
